export const $LONE = {
	"ASCII": false,
	"ASCII_Hex_Digit": false,
	"AHex": false,
	"Alphabetic": false,
	"Alpha": false,
	"Any": false,
	"Assigned": false,
	"Bidi_Control": false,
	"Bidi_C": false,
	"Bidi_Mirrored": false,
	"Bidi_M": false,
	"Case_Ignorable": false,
	"CI": false,
	"Cased": false,
	"Changes_When_Casefolded": false,
	"CWCF": false,
	"Changes_When_Casemapped": false,
	"CWCM": false,
	"Changes_When_Lowercased": false,
	"CWL": false,
	"Changes_When_NFKC_Casefolded": false,
	"CWKCF": false,
	"Changes_When_Titlecased": false,
	"CWT": false,
	"Changes_When_Uppercased": false,
	"CWU": false,
	"Dash": false,
	"Default_Ignorable_Code_Point": false,
	"DI": false,
	"Deprecated": false,
	"Dep": false,
	"Diacritic": false,
	"Dia": false,
	"Emoji": false,
	"Emoji_Component": false,
	"Emoji_Modifier": false,
	"Emoji_Modifier_Base": false,
	"Emoji_Presentation": false,
	"Extender": false,
	"Ext": false,
	"Grapheme_Base": false,
	"Gr_Base": false,
	"Grapheme_Extend": false,
	"Gr_Ext": false,
	"Hex_Digit": false,
	"Hex": false,
	"IDS_Binary_Operator": false,
	"IDSB": false,
	"IDS_Trinary_Operator": false,
	"IDST": false,
	"ID_Continue": false,
	"IDC": false,
	"ID_Start": false,
	"IDS": false,
	"Ideographic": false,
	"Ideo": false,
	"Join_Control": false,
	"Join_C": false,
	"Logical_Order_Exception": false,
	"LOE": false,
	"Lowercase": false,
	"Lower": false,
	"Math": false,
	"Noncharacter_Code_Point": false,
	"NChar": false,
	"Pattern_Syntax": false,
	"Pat_Syn": false,
	"Pattern_White_Space": false,
	"Pat_WS": false,
	"Quotation_Mark": false,
	"QMark": false,
	"Radical": false,
	"Regional_Indicator": false,
	"RI": false,
	"Sentence_Terminal": false,
	"STerm": false,
	"Soft_Dotted": false,
	"SD": false,
	"Terminal_Punctuation": false,
	"Term": false,
	"Unified_Ideograph": false,
	"UIdeo": false,
	"Uppercase": false,
	"Upper": false,
	"Variation_Selector": false,
	"VS": false,
	"White_Space": false,
	"space": false,
	"XID_Continue": false,
	"XIDC": false,
	"XID_Start": false,
	"XIDS": false
};

export const General_Category = {
	"Cased_Letter": false,
	"LC": false,
	"Close_Punctuation": false,
	"Pe": false,
	"Connector_Punctuation": false,
	"Pc": false,
	"Control": false,
	"Cc": false,
	"cntrl": false,
	"Currency_Symbol": false,
	"Sc": false,
	"Dash_Punctuation": false,
	"Pd": false,
	"Decimal_Number": false,
	"Nd": false,
	"digit": false,
	"Enclosing_Mark": false,
	"Me": false,
	"Final_Punctuation": false,
	"Pf": false,
	"Format": false,
	"Cf": false,
	"Initial_Punctuation": false,
	"Pi": false,
	"Letter": false,
	"L": false,
	"Letter_Number": false,
	"Nl": false,
	"Line_Separator": false,
	"Zl": false,
	"Lowercase_Letter": false,
	"Ll": false,
	"Mark": false,
	"M": false,
	"Combining_Mark": false,
	"Math_Symbol": false,
	"Sm": false,
	"Modifier_Letter": false,
	"Lm": false,
	"Modifier_Symbol": false,
	"Sk": false,
	"Nonspacing_Mark": false,
	"Mn": false,
	"Number": false,
	"N": false,
	"Open_Punctuation": false,
	"Ps": false,
	"Other": false,
	"C": false,
	"Other_Letter": false,
	"Lo": false,
	"Other_Number": false,
	"No": false,
	"Other_Punctuation": false,
	"Po": false,
	"Other_Symbol": false,
	"So": false,
	"Paragraph_Separator": false,
	"Zp": false,
	"Private_Use": false,
	"Co": false,
	"Punctuation": false,
	"P": false,
	"punct": false,
	"Separator": false,
	"Z": false,
	"Space_Separator": false,
	"Zs": false,
	"Spacing_Mark": false,
	"Mc": false,
	"Surrogate": false,
	"Cs": false,
	"Symbol": false,
	"S": false,
	"Titlecase_Letter": false,
	"Lt": false,
	"Unassigned": false,
	"Cn": false,
	"Uppercase_Letter": false,
	"Lu": false
};

export const Script = {
	"Adlam": false,
	"Adlm": false,
	"Ahom": false,
	"Anatolian_Hieroglyphs": false,
	"Hluw": false,
	"Arabic": false,
	"Arab": false,
	"Armenian": false,
	"Armn": false,
	"Avestan": false,
	"Avst": false,
	"Balinese": false,
	"Bali": false,
	"Bamum": false,
	"Bamu": false,
	"Bassa_Vah": false,
	"Bass": false,
	"Batak": false,
	"Batk": false,
	"Bengali": false,
	"Beng": false,
	"Bhaiksuki": false,
	"Bhks": false,
	"Bopomofo": false,
	"Bopo": false,
	"Brahmi": false,
	"Brah": false,
	"Braille": false,
	"Brai": false,
	"Buginese": false,
	"Bugi": false,
	"Buhid": false,
	"Buhd": false,
	"Canadian_Aboriginal": false,
	"Cans": false,
	"Carian": false,
	"Cari": false,
	"Caucasian_Albanian": false,
	"Aghb": false,
	"Chakma": false,
	"Cakm": false,
	"Cham": false,
	"Cherokee": false,
	"Cher": false,
	"Common": false,
	"Zyyy": false,
	"Coptic": false,
	"Copt": false,
	"Qaac": false,
	"Cuneiform": false,
	"Xsux": false,
	"Cypriot": false,
	"Cprt": false,
	"Cyrillic": false,
	"Cyrl": false,
	"Deseret": false,
	"Dsrt": false,
	"Devanagari": false,
	"Deva": false,
	"Duployan": false,
	"Dupl": false,
	"Egyptian_Hieroglyphs": false,
	"Egyp": false,
	"Elbasan": false,
	"Elba": false,
	"Ethiopic": false,
	"Ethi": false,
	"Georgian": false,
	"Geor": false,
	"Glagolitic": false,
	"Glag": false,
	"Gothic": false,
	"Goth": false,
	"Grantha": false,
	"Gran": false,
	"Greek": false,
	"Grek": false,
	"Gujarati": false,
	"Gujr": false,
	"Gurmukhi": false,
	"Guru": false,
	"Han": false,
	"Hani": false,
	"Hangul": false,
	"Hang": false,
	"Hanunoo": false,
	"Hano": false,
	"Hatran": false,
	"Hatr": false,
	"Hebrew": false,
	"Hebr": false,
	"Hiragana": false,
	"Hira": false,
	"Imperial_Aramaic": false,
	"Armi": false,
	"Inherited": false,
	"Zinh": false,
	"Qaai": false,
	"Inscriptional_Pahlavi": false,
	"Phli": false,
	"Inscriptional_Parthian": false,
	"Prti": false,
	"Javanese": false,
	"Java": false,
	"Kaithi": false,
	"Kthi": false,
	"Kannada": false,
	"Knda": false,
	"Katakana": false,
	"Kana": false,
	"Kayah_Li": false,
	"Kali": false,
	"Kharoshthi": false,
	"Khar": false,
	"Khmer": false,
	"Khmr": false,
	"Khojki": false,
	"Khoj": false,
	"Khudawadi": false,
	"Sind": false,
	"Lao": false,
	"Laoo": false,
	"Latin": false,
	"Latn": false,
	"Lepcha": false,
	"Lepc": false,
	"Limbu": false,
	"Limb": false,
	"Linear_A": false,
	"Lina": false,
	"Linear_B": false,
	"Linb": false,
	"Lisu": false,
	"Lycian": false,
	"Lyci": false,
	"Lydian": false,
	"Lydi": false,
	"Mahajani": false,
	"Mahj": false,
	"Malayalam": false,
	"Mlym": false,
	"Mandaic": false,
	"Mand": false,
	"Manichaean": false,
	"Mani": false,
	"Marchen": false,
	"Marc": false,
	"Masaram_Gondi": false,
	"Gonm": false,
	"Meetei_Mayek": false,
	"Mtei": false,
	"Mende_Kikakui": false,
	"Mend": false,
	"Meroitic_Cursive": false,
	"Merc": false,
	"Meroitic_Hieroglyphs": false,
	"Mero": false,
	"Miao": false,
	"Plrd": false,
	"Modi": false,
	"Mongolian": false,
	"Mong": false,
	"Mro": false,
	"Mroo": false,
	"Multani": false,
	"Mult": false,
	"Myanmar": false,
	"Mymr": false,
	"Nabataean": false,
	"Nbat": false,
	"New_Tai_Lue": false,
	"Talu": false,
	"Newa": false,
	"Nko": false,
	"Nkoo": false,
	"Nushu": false,
	"Nshu": false,
	"Ogham": false,
	"Ogam": false,
	"Ol_Chiki": false,
	"Olck": false,
	"Old_Hungarian": false,
	"Hung": false,
	"Old_Italic": false,
	"Ital": false,
	"Old_North_Arabian": false,
	"Narb": false,
	"Old_Permic": false,
	"Perm": false,
	"Old_Persian": false,
	"Xpeo": false,
	"Old_South_Arabian": false,
	"Sarb": false,
	"Old_Turkic": false,
	"Orkh": false,
	"Oriya": false,
	"Orya": false,
	"Osage": false,
	"Osge": false,
	"Osmanya": false,
	"Osma": false,
	"Pahawh_Hmong": false,
	"Hmng": false,
	"Palmyrene": false,
	"Palm": false,
	"Pau_Cin_Hau": false,
	"Pauc": false,
	"Phags_Pa": false,
	"Phag": false,
	"Phoenician": false,
	"Phnx": false,
	"Psalter_Pahlavi": false,
	"Phlp": false,
	"Rejang": false,
	"Rjng": false,
	"Runic": false,
	"Runr": false,
	"Samaritan": false,
	"Samr": false,
	"Saurashtra": false,
	"Saur": false,
	"Sharada": false,
	"Shrd": false,
	"Shavian": false,
	"Shaw": false,
	"Siddham": false,
	"Sidd": false,
	"SignWriting": false,
	"Sgnw": false,
	"Sinhala": false,
	"Sinh": false,
	"Sora_Sompeng": false,
	"Sora": false,
	"Soyombo": false,
	"Soyo": false,
	"Sundanese": false,
	"Sund": false,
	"Syloti_Nagri": false,
	"Sylo": false,
	"Syriac": false,
	"Syrc": false,
	"Tagalog": false,
	"Tglg": false,
	"Tagbanwa": false,
	"Tagb": false,
	"Tai_Le": false,
	"Tale": false,
	"Tai_Tham": false,
	"Lana": false,
	"Tai_Viet": false,
	"Tavt": false,
	"Takri": false,
	"Takr": false,
	"Tamil": false,
	"Taml": false,
	"Tangut": false,
	"Tang": false,
	"Telugu": false,
	"Telu": false,
	"Thaana": false,
	"Thaa": false,
	"Thai": false,
	"Tibetan": false,
	"Tibt": false,
	"Tifinagh": false,
	"Tfng": false,
	"Tirhuta": false,
	"Tirh": false,
	"Ugaritic": false,
	"Ugar": false,
	"Vai": false,
	"Vaii": false,
	"Warang_Citi": false,
	"Wara": false,
	"Yi": false,
	"Yiii": false,
	"Zanabazar_Square": false,
	"Zanb": false
};

export default { $LONE, General_Category, Script }